const api = '/api/v1/user';
import axios from 'axios';
export const userRepository =  {
    methods: {
        async Create(data){
            return  axios.post(api+ "/create.php",data)
        },
        async getChild(){
            return  axios.get(api+ "/child.php")
        },
        async getAdmin(){
            return  axios.get(api+ "/allAdmin.php")
        },
        async change(data){
            return  axios.post(api+ "/change.php", data)
        },
        async stop(data){
            return  axios.post(api+ "/stop.php", data)
        },
        async restart(data){
            return  axios.post(api+ "/restart.php", data)
        },
        async change(data){
            return  axios.post(api+ "/change.php", data)
        },
        async setRoomId(roomId){
            return axios.post(api+"/room.php",{roomId})
        }
    }
};

